import { Component, inject, OnInit } from '@angular/core';
import { InboxComponent } from '../../general/inbox/inbox.component';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, lastValueFrom, Observable, Subject } from 'rxjs';
import { ITable, TypeColumn } from '@/interface/general/ITable';
import { IDataPagination, IPagination } from '@/interface/general/IPagination';
import { IServerSide } from '@/shared/components/general/table-generic/interface/table-generic.interface';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { environment } from 'src/environments/environment';
import { KeyValueArrayGeneric } from '@/interface/general/params.interface';
import { IDataMotivo, IMotivo } from '../botonera.interface';
import { BotoneraApiService } from '../botonera.api.service';


@Component({
  selector: 'app-modal-ver-motivos',
  standalone: true,
  imports: [CommonModule, InboxComponent],
  templateUrl: './modal-ver-motivos.component.html',
  styleUrl: './modal-ver-motivos.component.scss',
})
export class ModalVerMotivosComponent implements OnInit {
  tableSubject$ = new BehaviorSubject<ITable | null>(null);
  dataSubject$ = new Subject<IDataPagination<IDataMotivo>>();
  url!: string;

  // Configuración de paginación
  rowsPerPageOptions = environment.paginationLarge;
  rowsPerPage = this.rowsPerPageOptions[0];
  currentPagination?: IPagination;

  dialogConfig = inject(DynamicDialogConfig);
  apiService = inject(BotoneraApiService);

  ngOnInit(): void {
    this.setTable();
    this.loadMotivos();
  }

  setTable() {
    const table: ITable = {
      fieldId: 'IdfdArchivo',
      paginator: true,
      rowsPerPageOptions: this.rowsPerPageOptions,
      lazyLoadOnInit: true,
      columns: [
         {
          field: 'NombreTipoMotivo',
          label: 'Tipo Motivo',
          type: TypeColumn.TRUNCATE_TEXT,
        },
        {
          field: 'Empresa',
          label: 'Empresa',
          type: TypeColumn.TRUNCATE_TEXT,
        },
        {
          field: 'Motivo',
          label: 'Mensaje',
          type: TypeColumn.TRUNCATE_TEXT,
        },
        {
          field: 'Usuario',
          label: 'Usuario',
          type: TypeColumn.TRUNCATE_TEXT,
        },
        {
          field: 'FechaRegistroTexto',
          label: 'Fecha Registro',
          type: TypeColumn.DATE,
        },
      ],
    };
    this.tableSubject$.next(table);
  }

  async loadMotivos(event?: IPagination): Promise<void> {
    let _IdfdArchivo = this.dialogConfig.data.IdfdArchivo;
    let _CodRadicado = this.dialogConfig.data.CodRadicado;
    const listMotivos = await lastValueFrom(this.apiService.GetVerMotivos(_IdfdArchivo,_CodRadicado, event));

    this.dataSubject$.next({
      data: listMotivos,
      totalRecords: listMotivos.length,
      pagination: event,
    });
  }  
}
